import React, { useEffect, useState } from "react";
import ExcelJS from "exceljs";
import Tabla from "./Tabla/index";
import TRANS from "../../../assets/vw/svg/transacciones.svg";
import Loading from "../../../components/Loading";
import cerrar from "../../../assets/vw/svg/cerrar.svg";
import Menu from "../../../components/Menu";
import Modal from "../../../components/Modal";

/** @typedef {import("react-router-dom").RouteComponentProps} RouteComponentProps */

/**
 * @param {RouteComponentProps} props
 * @returns {JSX.Element}
 */
export default function Transacciones(props) {
  const backendUrl = process.env.REACT_APP_URL_DTO_BACK;
  const apiTransacciones = backendUrl + "transacciones";

  const [loading, setLoading] = useState(false);
  const [queryParams, setQueryParams] = useState("");

  const [aplicaciones, setAplicaciones] = useState([]);
  const [fetchedTransacciones, setFetchedTransacciones] = useState([]);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [total, setTotal] = useState(0);
  const [modal, setModal] = useState({
    active: false,
    message: '',
    success: false,
    tryAgain: false
  }); 

  async function getTransacciones() {
    setLoading(true);
    const url = apiTransacciones + "?" + queryParams;
    setModal({
      active: false,
      message: '',
      success: false
    });
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + props.servicio.getToken(),
          "Content-Type": "application/json",
        },
      });

      if(response.ok){
        if(response.status === 504){
          setModal({
            active: true,
            message: "Tiempo de espera agotado",
            success: false,
            tryAgain: true
          });
          return;
        } 

        const data = await response.json();

        if (data.statusCode === 200) {
          const bodyJson = JSON.parse(data.body);
          const mensaje = bodyJson.mensaje;
  
          if (Number(mensaje)) {
            setMostrarModal(true)
            setTotal(Number(mensaje))
          }
          else{
            // Quitar comillas dobles y comillas simples
            let aux = mensaje.replace(/"/g, "").replace(/'/g, "");
            // Parsear el string a un array de objetos
            const objects = parseMensaje(aux);
            setFetchedTransacciones(objects);
          }
  
        } else {
          setModal({
            active: true,
            message: JSON.parse(data.body).mensaje,
            success: false
          });
        }
      }else{
        throw Error('Error al recibir la respuesta de servidor');
      }
      
    } catch (error) {
      console.error(error.stack || error);
      setModal({
        active: true,
        message: error.message,
        success: false
      });
    } finally {
      setLoading(false);
    }
  }

  function parseMensaje(str) {
    const trimmed = str.trim();
    const inner = trimmed.slice(1, -1);
  
    const objects = [];
    let depth = 0;
    let buffer = '';
    let inQuotes = false;
  
    for (let i = 0; i < inner.length; i++) {
      const char = inner[i];
  
      if (char === '"' && inner[i - 1] !== '\\') {
        inQuotes = !inQuotes;
      }
  
      if (!inQuotes) {
        if (char === '{') depth++;
        if (char === '}') depth--;
      }
  
      buffer += char;
  
      if (depth === 0 && buffer.trim()) {
        const clean = buffer.trim().replace(/^,|,$/g, '');
        if (clean.includes(':')) {
          objects.push(clean);
        }
        buffer = '';
      }
    }
  
    return objects
      .map(objStr => {
        const result = {};
  
        // Extraer cuerpo como string
        const cuerpoMatch = objStr.match(/cuerpo\s*:\s*\{([^{}]*)\}/);
        if (cuerpoMatch) {
          result.cuerpo = cuerpoMatch[1].trim();
          objStr = objStr.replace(/cuerpo\s*:\s*\{[^{}]*\},?/, '');
        }
  
        // Quitar llaves externas
        objStr = objStr.replace(/^{|}$/g, '');
  
        const pairs = objStr.split(',').map(s => s.trim()).filter(Boolean);
        for (const pair of pairs) {
          const [key, ...valParts] = pair.split(':');
          if (!key || valParts.length === 0) continue;
  
          const rawValue = valParts.join(':').trim();
  
          // Detectar tipo de valor
          let parsedValue;
          if (rawValue === 'true') {
            parsedValue = true;
          } else if (rawValue === 'false') {
            parsedValue = false;
          } else if (!isNaN(rawValue)) {
            parsedValue = Number(rawValue);
          } else {
            parsedValue = rawValue;
          }
  
          result[key.trim()] = parsedValue;
        }
  
        return result;
      })
      .filter(obj => Object.keys(obj).length > 0);
  }  

  async function getAplicaciones() {
    setLoading(true);
    setModal({
      active: false,
      message: '',
      success: false
    });
    try {
      const response = await fetch(backendUrl + "aplicacion?todos", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + props.servicio.getToken(),
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.mensaje);
      }

      setAplicaciones(data.mensaje);
    } catch (error) {
      console.error(error.stack || error);
      setModal({
        active: true,
        message: error.message,
        success: false
      });
    } finally {
      setLoading(false);
    }
  }

 function exportar () {
    generarExcel(fetchedTransacciones, aplicaciones)
  };

  useEffect(() => {
    getAplicaciones();
  }, []);

  useEffect(() => {
    if (queryParams) {
      getTransacciones();
    }
  }, [queryParams]);

  const buildPopUpContar = () => {
    return (
      <div
        className={`modal modal_vw fade ${mostrarModal ? "show" : ""}`}
        id="desarchivar"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex="-1"
        aria-labelledby="desarchivarLabel"
        style={mostrarModal ? { display: "block" } : {}}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered ">
          <div className="modal-content modal_content-vw">
            <div className="modal-header modal_header-vw">
              <div className="d-flex justify-content-end">
                <button
                  className="button_icon-vw"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setMostrarModal(false);
                  }}
                >
                  <img src={cerrar} alt="cerrar"></img>
                </button>
              </div>
            </div>
            <div className={`modal-body p-5`}>
            <div className="mt-2 px-2 mensaje_confirmacion mb-5">
            <div className="d-flex justify-content-center">
            </div>
            <label className="d-flex justify-content-center">
              {"Total de registros: "+total}
            </label>
          </div>
            </div>
          </div>
        </div>
      </div>
    );
  };


  return (
    <>
    <Menu/>
    <Modal modalInfo={modal} setMostrarModal={setModal} />
    {
      loading && <Loading />
    }
      <div className={`navegacion`}>
        <>
          <div className="row posicionMenu">
            <ul className="d-flex px-0 my-0">
              <li className="opcion-ruta">
                <div className={`nav-link active ps-0 active border_menu`}>
                  <img src={TRANS} alt="app" className="icono-menu me-2" />
                  Transacciones
                </div>
              </li>
            </ul>
          </div>
          <div className="row border_vw pt-4 m-0">
            <div className="col-12 p-0 contenedor-table">

             { ( aplicaciones.length > 0 ) && <Tabla
                data={fetchedTransacciones}
                aplicaciones={aplicaciones}
                setQueryParams={setQueryParams}
                servicio={props.servicio}
                exportar = {exportar}
              />}
            </div>
          </div>
        </>
      </div>
      {buildPopUpContar()}
    </>
  );
}

function generarExcel(rows, aplicaciones) {
  const workbook = new ExcelJS.Workbook();

  const worksheet = workbook.addWorksheet("Transacciones");

  worksheet.columns = [
    { header: "ID", key: "id", width: 10 },
    { header: "App", key: "app", width: 24 },
    { header: "Usuario", key: "usuario", width: 26 },
    { header: "Método", key: "metodo", width: 10 },
    { header: "Estado", key: "estado", width: 10 },
    { header: "URL", key: "url", width: 32 },
    { header: "Cuerpo", key: "cuerpo", width: 32 },
    { header: "Fecha de creación", key: "fechaCreacion", width: 32 },
  ];

  const headers = worksheet.getRow(1);
  headers.font = { bold: true, size: 14 };
  headers.alignment = { horizontal: "center" };
  headers.fill = {
    type: "pattern",
    pattern: "lightGray",
  };

  rows.forEach((row) => {
    worksheet.addRow({
      ...row,
      app: aplicaciones.find((app) => app.idApp === row.app)?.nombre || "",
      fechaCreacion: new Date(row.fechaCreacion).toLocaleString(),
    });
  });

  const date = new Date();
  const dateString = date.toISOString().split("T")[0];
  const timeString = date.toTimeString().split(" ")[0];
  const dateTimeString = `${dateString} ${timeString}`;

  const fileName = `Transacciones_${dateTimeString}.xlsx`;

  workbook.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], { type: "application/vnd.ms-excel" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.click();
  });
}
